import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import SOVFiltersTimeframe from './timeframe/SOVFiltersTimeframe';
import SOVFiltersCountries from './countries/SOVFiltersCountries';

import './sov-filters.scss';

import type { MixedSelectDropdownItem } from 'types';
import type { SOVReport } from 'modules/insights/sov/types';

applyTranslations(require('./sov-filters.i18n.json'));

type Props = {
  report: SOVReport,
  isInvalidForm?: boolean,
  startDate: string | undefined | null,
  endDate: string | undefined | null,
  limitSelectableDates: boolean,
  countries: Array<MixedSelectDropdownItem>,
  onTimeframeChange: (b?: string | null, a?: string | null) => void,
  onCountriesChange: (countries: Array<string | undefined>) => void
};

const MSG_KEY = 'sov_filters';

class SOVFilters extends React.PureComponent<Props> {
  renderHeader(): React.ReactNode {
    return (
      <div className="sov-filters__header">
        <div className="sov-filters__header-text">
          {__t(`${MSG_KEY}.labels.filters`)}
        </div>
      </div>
    );
  }

  renderCountries(): React.ReactNode {
    const { report, countries, isInvalidForm, onCountriesChange } = this.props;

    return (
      <SOVFiltersCountries
        report={report}
        countries={countries}
        withErrorHighlight={isInvalidForm}
        onCountriesChange={onCountriesChange}
      />
    );
  }

  renderTimeframe(): React.ReactNode {
    const { startDate, endDate, isInvalidForm, limitSelectableDates, onTimeframeChange } = this.props;

    return (
      <SOVFiltersTimeframe
        startDate={startDate}
        endDate={endDate}
        limitSelectableDates={limitSelectableDates}
        withErrorHighlight={isInvalidForm}
        onTimeframeChange={onTimeframeChange}
      />
    );
  }

  renderFilters(): React.ReactNode {
    return (
      <div className="sov-filters__filters">
        {this.renderTimeframe()}
        {this.renderCountries()}
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-filters">
        {this.renderHeader()}
        {this.renderFilters()}
      </div>
    );
  }
}

export default SOVFilters;
